import axios from 'axios';
import { setAuthToken } from 'actions/util/setAuthToken';
import jwt from 'jsonwebtoken';
import { setSessionSettings } from 'actions/sessionSettings';
import { openLoader, closeLoader } from 'actions/loader';
import { openErrorModal } from 'actions/modals';
import { handleError } from 'actions/util/requestUtils';
import { userActions } from 'actions/api/users';
import { store } from 'index';

// sign in
export function getToken({ data }) {
  const ROOT_URL = process.env.API_ROUTE + 'v1/';
  let response;

  store.dispatch(openLoader());

  return new Promise(async (resolve, reject) => {
    const route = data.sso
      ? `${ROOT_URL}social_token`
      : `${ROOT_URL}user_token`;

    try {
      response = await axios.post(route, { auth: data });
      const token = response.data.jwt;
      localStorage.setItem('token', token);
      setAuthToken(token);
      const currentUser = jwt.decode(token);
      store.dispatch(
        setSessionSettings({ path: ['currentUserId'], data: currentUser.sub })
      );
      await store.dispatch(
        userActions.search({ data: { id: currentUser.sub } })
      );
      store.dispatch(closeLoader());
      resolve(currentUser);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        store.dispatch(
          openErrorModal({ text: 'Invalid username or password' })
        );
      } else {
        handleError(e);
      }
      store.dispatch(closeLoader());
      reject(e);
    }
  });
}

export function signOut() {
  localStorage.removeItem('token');
  setAuthToken(false);
}



// WEBPACK FOOTER //
// ./src/actions/auth/userToken.js